module.exports = __webpack_public_path__ + "img/Banner.158ce5e2.jpg";